<template lang="de">
  <div role="img" v-ripple>
    <v-carousel
      cycle
      :hide-delimiters=true
      :continuous=true
      :cycle=picRotation
      :show-arrows-on-hover=true
      :show-arrows=rotationFeatures
      height="auto"
      >
  <!-- Das hier muss geändert werden -->
    <v-carousel-item
    
      v-for="(item, i) in layout.pictures" :key="i"
      eager
    >
    <v-img 
    :max-height="layout.pictureSize"
    :src="item.src"
    eager
    @click="toggleButton()"
     ></v-img>
    </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
import carouselButton from "../components/carouselButton.vue";

export default {
  components: {
    carouselButton,
  },

  methods: {
    toggleButton() {
      this.picRotation = !this.picRotation;
    },
  },

  computed: {
    rotationFeatures: {
      get() {
        if (this.layout.pictures.length == 1) {
          return false;
        } else {
          return true;
        }
      },
    },

    layout: {
      get() {
        return this.$store.state.pickedLayout;
      },
    },

    picRotation: {
      get() {
        return this.$store.state.picRotation;
      },
      set(value) {
        this.$store.commit("updatePicRotation", value);
      },
    },

    results: {
      get() {
        return this.$store.state.results;
      },
    },
  },
};
</script>
<style lang="de">
</style>